import { useState } from 'react';
import { get } from 'lodash';
import { ajaxExceptionMessage } from '@skunexus/utils';

export function useImprovedExport({
    exportApi,
    successMessage = 'The request is being processed. An email will be sent to you when the CSV export is available.',
    exportConfig = {},
    successNotification = () => {},
    errorNotification = () => {},
}) {
    const [loading, setLoading] = useState(false);

    const handleExportData = async (payload) => {
        setLoading(true);
        const processPayload = get(exportConfig, 'customProcessPayload', (data) => data);

        try {
            const result = await exportApi({
                payload: processPayload(payload),
                apiConfig: get(exportConfig, 'apiConfig', {}),
                requestConfig: get(exportConfig, 'requestConfig', {}),
            });

            if (!get(result, 'data.success', false)) {
                throw new Error(get(exportConfig, 'errorMessage', 'Something went wrong during export operation.'));
            }
            setLoading(false);
            successNotification(successMessage);
        } catch (e) {
            console.log('error', e);
            setLoading(false);
            errorNotification(ajaxExceptionMessage(e));
        }
    };

    const handleExportAll = (payload) => {
        handleExportData(payload);
    };
    const handleExportAllWithCurrentCols = (payload) => {
        handleExportData(payload);
    };
    return {
        isLoading: loading,
        handleExportAll,
        handleExportAllWithCurrentCols,
    };
}
